import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgArrowDown = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M16 6.66667V25.3333",
		fill: "none",
		stroke: "currentColor",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M25.3333 16L16 25.3333L6.66667 16",
		fill: "none",
		stroke: "currentColor",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
export { SvgArrowDown as ReactComponent };
